import React, { useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { Skeleton, Button, Modal, Card, Flex, theme, Space, Tabs, Empty, Segmented, ConfigProvider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faThLarge } from '@fortawesome/free-solid-svg-icons';
import { BACKEND_URL_QUOTATION } from 'Config/routes';
import selectInsuranceQuotations from 'Api/actions/quotation/selectInsuranceQuotations';

import { setSelectedPackages } from 'Redux/actions/comparationQuotationActions';
import ModalDetails from 'Components/commonComponents/modal_details';

import { TabLabel } from 'Components/TabLabel';
import InsurancePackageCard, { getPaymentData, SmallInsuranceCard } from '../InsurancePackageCard';
import DummyLoadingCards from './DummyLoadingCards';
import InsuranceCarrierPackageDummyCard from './InsuranceCarrierPackageDummyCard';
// import Table from './Table';
import { RequoteActionButton } from './RequoteActionButton';
import { useNavigate } from 'react-router-dom';
import { useDataGatewayPageStore } from '../../useQuotationsComparatorPageStore';
import { ROUTES } from '@/App/Router/routes';
import { QUOTATION_INSURANCE_CARRIER_STATE } from '@shared/constants/quotationInsuranceCarrierStates';

const TAB_ACTIVE = 'active';
const TAB_INACTIVE = 'inactive';
const MAX_PACKAGE_SELECTION = 7;

const Main = ({
  quotation,
  packages,
  inactivePackages = [],
  loading = false,
  coverages,
  assists,
  aseguradoras,
  setSelectedPackagesAction,
  selectedPackages,
  loadingQuotations = false,
  parentBottomPadding,
  userProfileId,
}) => {
  const navigate = useNavigate();

  const isListMode = useDataGatewayPageStore((state) => state.isListMode);
  const setIsListMode = useDataGatewayPageStore((state) => state.setIsListMode);

  const [packagesDetailShowState, setackPagesDetailShowState] = useState({
    packageSelectedDetail: null,
    isVisible: false,
    handleCancel: () => { },
    insuranceCarrier: null,
  });

  const { token: themeToken } = theme.useToken();
  const selectionBarAnchorRef = useRef(null);
  const selectionBarRef = useRef(null);
  const [selectionBarBox, setSelectionBarBox] = useState({ left: 0, width: 0, height: 0 });

  useLayoutEffect(() => {
    if (!selectedPackages.length) return undefined;

    const anchor = selectionBarAnchorRef.current;
    const row = anchor?.closest('.ant-row');

    const update = () => {
      const bar = selectionBarRef.current;
      if (!anchor || !bar) return;
      const rect = (row || anchor).getBoundingClientRect();
      bar.style.left = `${rect.left}px`;
      bar.style.width = `${rect.width}px`;
      const next = { left: rect.left, width: rect.width, height: bar.offsetHeight };
      if (row) row.style.paddingBottom = `${Math.max(next.height - (parentBottomPadding || 0), 0)}px`;
      setSelectionBarBox((current) => (
        current.left === next.left && current.width === next.width && current.height === next.height ? current : next
      ));
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(selectionBarRef.current);
    window.addEventListener('resize', update);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
      if (row) row.style.paddingBottom = '';
    };
  }, [selectedPackages.length, parentBottomPadding]);

  // Función para filter una asegura a partir del ID
  const filterInsuranceCarrier = (insuranceCarrierId) => {
    const insuranceCarrierFiltered = aseguradoras.find((aseguradora) => aseguradora.id === insuranceCarrierId);
    return insuranceCarrierFiltered;
  }

  // ==================== ==================== ==================== ==================== ====================
  const handleShowModalDetail = (idPackage) => {
    // Si el paquete no se encuentra en la lista de paquetes activos, se busca en la lista de paquetes inactivos
    const packagesDetail =
      packages.find((itemPackage) => itemPackage.id === idPackage) ??
      inactivePackages.find((itemPackage) => itemPackage.id === idPackage);

    const insuranceCarrier = filterInsuranceCarrier(packagesDetail.insurance_carrier)
    setackPagesDetailShowState({
      packageSelectedDetail: packagesDetail,
      isVisible: true,
      handleCancel: () => setackPagesDetailShowState({ isVisible: false }),
      insuranceCarrier,
    })
  };

  const onSelectPackage = (isSelected, selectedPackage) => {
    // No se permite seleccionar paquetes mientras se completa la información del PDF
    if (isSelected && selectedPackage.state === QUOTATION_INSURANCE_CARRIER_STATE.PROCESSING) {
      return;
    }

    let newSelectedPackages = selectedPackages.map((item) => item);
    if (isSelected) {
      newSelectedPackages.push(selectedPackage);
    } else {
      newSelectedPackages = selectedPackages.filter((packege) => packege.id !== selectedPackage.id);
    }
    setSelectedPackagesAction(newSelectedPackages);
  };

  const reloadWindow = () => {
    //window.location.href = ``;
    navigate(ROUTES.QUOTATIONS.CREATE);
  };

  const countDown = (error) => {
    let secondsToGo = 60;
    let message;
    let modal;
    let down = <p>Se cerrará automáticamente en {secondsToGo} segundos.</p>;
    if (error) {
      message = <p>Hubo un error al procesar la información, por favor intente más tarde.</p>;
      modal = Modal.error({
        title: 'Gracias por elegirnos!',
        content: React.createElement('div', {}, [message, down]),
        okText: 'Confirmar',
        cancelButtonProps: { ghost: true },
      });
    } else {
      message = <p>Tu solicitud ya fue generada, nuestro equipo se pondrá en contacto.</p>;
      modal = Modal.info({
        title: 'Gracias por elegirnos!',
        content: React.createElement('div', {}, [message, down]),
        okText: 'Confirmar',
        okButtonProps: {
          onClick: () => {
            clearTimeout(timeoutId);
            modal.destroy();
            reloadWindow();
          }
        },
        cancelButtonProps: { ghost: true },
      });
    }
    const timer = setInterval(() => {
      secondsToGo -= 1;
      down = <p>Se cerrará automáticamente en {secondsToGo} segundos.</p>;
      modal.update({
        content: React.createElement('div', {}, [message, down]),
      });
    }, 1000);
    const timeoutId = setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
      if (!error) {
        reloadWindow();
      }
    }, secondsToGo * 1000);
  };

  const handleComparatorPage = () => {
    // se filtran solo los dis para enviar al back
    const selectedPackagesIds = selectedPackages.map((item) => item.id);
    const external_session = localStorage.getItem('external_session') === "true" || false;

    selectInsuranceQuotations(quotation.id, { insurance_quotations_selected: selectedPackagesIds })
      .then(() => {

        if (external_session) {
          //send email
          const token = localStorage.getItem('token');
          axios({
            method: 'POST',
            url: `${BACKEND_URL_QUOTATION}${quotation.id}/send/`,
            data: { emails: ['external'].toString() },
            headers: {
              Authorization: `Token ${token}`,
            },
          }).then((response) => {
            countDown(false);
          }).catch(() => {
            countDown(true);
          });

        } else {
          // Se redirige a la página de compración
          navigate(ROUTES.QUOTATIONS.PLANS.COMPARISON(quotation.id));
          // history.push({
          //   pathname: '/quotations_comparator_diff',
          //   state: { insurance_quotations_selected: selectedPackages, idQuotations: quotation.id },
          // });
        }
      })
      .catch(() => {
        alert('No pudimos realizar esta acción, vuelve a intentarlo')
      });
  };

  // const settingsMenuItems = [
  //   {
  //     key: 'toggleDisplayMode',
  //     icon: <FontAwesomeIcon icon={faSyncAlt} />,
  //     label: `Vista: ${isListMode ? 'Tarjetas' : 'Tabla'}`,
  //     onClick: () => setIsListMode(!isListMode),
  //   },
  // ];

  // ==================== ==================== ==================== ==================== ====================
  if (loading) return (
    <div style={{ width: '100%' }}>
      <Skeleton active />
      <Skeleton active />
      <Skeleton active />
    </div>
  );

  const renderPackages = (records, readOnly = false) => {
    // if (isListMode) {
    //   return (
    //     <Table
    //       records={records}
    //       insuranceCarriers={aseguradoras}
    //       allCoverages={coverages}
    //       onViewMoreDetails={handleShowModalDetail}
    //       loading={!readOnly && loadingQuotations}
    //       selection={{
    //         selectedRowKeys: selectedPackages.map((item) => item.id),
    //         onSelect: (record, selected) => onSelectPackage(selected, record),
    //         maxSelections: MAX_PACKAGE_SELECTION,
    //       }}
    //       readOnly={readOnly}
    //     />
    //   );
    // }

    if (!records.length && !loadingQuotations) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;

    // Packages in progress (pending/started): card de carga; el resto usa InsurancePackageCard
    const isPackageInProgress = (packageData) => (
      packageData.state === QUOTATION_INSURANCE_CARRIER_STATE.PENDING
      || packageData.state === QUOTATION_INSURANCE_CARRIER_STATE.STARTED
    );

    return (
      // <Row>
      <div style={{ display: 'grid', gridTemplateColumns: isListMode ? '1fr' : 'repeat(auto-fill, minmax(310px, 1fr))', gap: '24px' }}>
        {records.map((packageData) => {
          if (!readOnly && isPackageInProgress(packageData)) {
            return (
              <InsuranceCarrierPackageDummyCard
                key={packageData.id}
                insuranceCarrier={filterInsuranceCarrier(packageData.insurance_carrier)}
                insurancePackage={packageData}
              />
            );
          }

          return (
            <InsurancePackageCard
              key={packageData.id}
              coverages={coverages}
              assists={assists}
              checkboxIsDisabled={selectedPackages.length >= MAX_PACKAGE_SELECTION}
              insurancePackage={packageData}
              onSelect={onSelectPackage}
              isSelected={!!selectedPackages.find((selectedPackage) => selectedPackage.id === packageData.id)}
              handleShowModalDetail={handleShowModalDetail}
              insuranceCarrier={filterInsuranceCarrier(packageData.insurance_carrier)}
              quotationId={quotation.id}
              readOnly={readOnly}
              isListMode={isListMode}
              userProfileId={userProfileId}
            />
          );
        })}
        {!readOnly && <DummyLoadingCards />}
      </div>
      // </Row>
    );
  };

  // if (!packages.length) return <h3>Ninguna cotización encontrada</h3>;
  return (<>
    <Flex vertical justify='space-between' gap='middle' style={{ height: '100%' }}>
      <Card
        style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
        styles={{ body: { padding: 0 } }}
      >
        <Tabs
          animated
          tabBarExtraContent={
            <Space size='middle'>
              {/* <Dropdown Dropdown menu={{ items: settingsMenuItems }} trigger={['click']}>
                <Tooltip title='Configuración'>
                  <Button color='primary' variant='text' shape='circle' icon={<FontAwesomeIcon icon={faCog} />} />
                </Tooltip>
              </Dropdown> */}
              <ConfigProvider
                theme={{
                  components: {
                    Segmented: {
                      itemColor: themeToken.colorPrimary,
                      itemHoverColor: themeToken.colorPrimary,
                      itemSelectedColor: themeToken.colorPrimary,
                      trackBg: `${themeToken.colorPrimary}1a`, // 10% de opacidad
                    },
                  },
                }}
              >
                <Segmented
                  value={isListMode ? 'list' : 'grid'}
                  onChange={(value) => setIsListMode(value === 'list')}
                  options={[
                    {
                      value: 'list',
                      icon: <FontAwesomeIcon icon={faList} />,
                    },
                    {
                      value: 'grid',
                      icon: <FontAwesomeIcon icon={faThLarge} />,
                    },
                  ]}
                />
              </ConfigProvider>
              <RequoteActionButton
                quotation={quotation}
                packages={packages}
                tooltip={loadingQuotations ? 'Hay cotizaciones en curso' : null}
                disabled={loadingQuotations}
              />
            </Space>
          }
          items={[
            {
              key: TAB_ACTIVE,
              label: <TabLabel title='Planes cotizados' count={packages.length} loading={loadingQuotations} />,
              children: renderPackages(packages),
            },
            {
              key: TAB_INACTIVE,
              label: <TabLabel title='Historial' count={inactivePackages.length} />,
              children: renderPackages(inactivePackages, true),
            },
          ]}
        />
      </Card>
      {selectedPackages.length > 0 && (
        <>
          <div ref={selectionBarAnchorRef} />
          <div
            ref={selectionBarRef}
            style={{
              position: 'fixed',
              bottom: 0,
              left: selectionBarBox.left,
              width: selectionBarBox.width,
              zIndex: 20,
              visibility: selectionBarBox.width ? 'visible' : 'hidden',
            }}
          >
            <Card
              size='small'
              style={{
                backgroundColor: `${themeToken.colorPrimary}0d`,
                backdropFilter: 'blur(10px)',
                border: `1px solid ${themeToken.colorPrimary}4d`,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }}>
              <Flex align='center' gap={12} style={{ width: '100%' }}>
                <Flex align='stretch' justify='flex-end' gap={8} wrap='nowrap' style={{ flex: '1 1 auto', minWidth: 0, overflowX: 'auto', paddingBottom: 8 }}>
                  {selectedPackages.map((selectedPackage) => (
                    <div key={selectedPackage.id} style={{ flex: '1 1 150px', minWidth: 132, maxWidth: 176 }}>
                      <SmallInsuranceCard
                        fluid
                        insuranceCarrier={aseguradoras.find((insuranceCarrier) => insuranceCarrier.id === selectedPackage.insurance_carrier)}
                        insurancePackage={selectedPackage}
                        onClose={(unSelectedPackage) => onSelectPackage(false, unSelectedPackage)}
                      />
                    </div>
                  ))}
                </Flex>
                <Button onClick={handleComparatorPage} type="primary" size="large" style={{ flex: '0 0 auto' }}>Comparar</Button>
              </Flex>
            </Card>
          </div>
        </>
      )}
    </Flex>
    <ModalDetails
      showModal={packagesDetailShowState.isVisible}
      handleCancel={packagesDetailShowState.handleCancel}
      packagesDetailShow={packagesDetailShowState.packageSelectedDetail}
      insuranceCarrier={packagesDetailShowState.insuranceCarrier}
      listCoverages={coverages}
      listAssists={assists}
    />
  </>);
};

Main.propTypes = {
  packages: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  quotation: PropTypes.shape({}).isRequired,
};

const actions = {
  setSelectedPackagesAction: setSelectedPackages,
};

const mapStateToProps = (state) => {
  let { packages, inactivePackages } = state.globalQuotation.quotation;

  const isPackageInProgress = (paquete) => (
    paquete.state === QUOTATION_INSURANCE_CARRIER_STATE.PENDING
    || paquete.state === QUOTATION_INSURANCE_CARRIER_STATE.STARTED
  );

  // FILTRAR LOS PAQUETES | Aseguradoras
  const fitersInsuranceCarriers = state.comparationQuotation.filters.selectedInsuranceCarriers;
  if (fitersInsuranceCarriers.length) {
    packages = packages.filter((paquete) => fitersInsuranceCarriers.includes(paquete.insurance_carrier));
    inactivePackages = inactivePackages.filter((paquete) => fitersInsuranceCarriers.includes(paquete.insurance_carrier));
  }

  // FILTRAR LOS PAQUETES | Coberturas — in progress no se filtra: aún no hay coberturas
  const filtersCoverages = state.comparationQuotation.filters.selectedCoverage;
  if (filtersCoverages.length) {
    packages = packages.filter((paquete) => {
      if (isPackageInProgress(paquete)) return true;
      const packageCoveragesIds = (paquete.coverages ?? []).map((packageCoverage) => packageCoverage.id);
      return filtersCoverages.every(filteredCoverageId => packageCoveragesIds.indexOf(filteredCoverageId) > -1);
    });

    inactivePackages = inactivePackages.filter((paquete) => {
      const packageCoveragesIds = (paquete.coverages ?? []).map((packageCoverage) => packageCoverage.id);
      return filtersCoverages.every(filteredCoverageId => packageCoveragesIds.indexOf(filteredCoverageId) > -1);
    });
  }

  // Filtrar por valor de la prima — in progress no se filtra: aún no hay primas
  const filterByPremium = (paquete) => {
    if (isPackageInProgress(paquete)) return true;
    const payment = getPaymentData(paquete)?.value ?? 0;
    if (premiumStart != null && payment < premiumStart) return false;
    if (premiumEnd != null && payment > premiumEnd) return false;
    return true;
  };

  const premiumStart = state.comparationQuotation.filters.premiumStart;
  const premiumEnd = state.comparationQuotation.filters.premiumEnd;
  if (premiumStart !== null || premiumEnd !== null) {
    packages = packages.filter(filterByPremium);
    inactivePackages = inactivePackages.filter(filterByPremium);
  }

  // Ordenar los packages según el campo seleccionado
  const sortBy = state.comparationQuotation.filters.sortBy
  const [sortField, sortOrder] = sortBy?.split('_') ?? [null, null];

  if (sortField) {
    const comparePackages = (a, b) => {
      let result = 0;

      if (sortField === 'insuranceCarrier') {
        const getInsuranceCarrierName = (id) => {
          const { name } = state.initialData.aseguradoras.find((insuranceCarrier) => insuranceCarrier.id === id) ?? {};
          return name ?? '';
        };

        result = getInsuranceCarrierName(a.insurance_carrier).localeCompare(getInsuranceCarrierName(b.insurance_carrier), 'es', { sensitivity: 'base' });
      } else if (sortField === 'premium') {
        result = (getPaymentData(a)?.value ?? 0) - (getPaymentData(b)?.value ?? 0);
      }

      // Aplica orden descendente si corresponde
      return sortOrder === 'desc' ? -result : result;
    };

    packages = [...packages].sort(comparePackages);
    inactivePackages = [...inactivePackages].sort(comparePackages);
  }

  return ({
    packages,
    inactivePackages,
    coverages: state.globalQuotation.quotation.coverages,
    assists: state.globalQuotation.quotation.assists,
    aseguradoras: state.initialData.aseguradoras,
    selectedPackages: state.comparationQuotation.selectedPackages,
    loadingQuotations: state.comparationQuotation.quotationPetitionAlive,
    userProfileId: state.initialData.user?.perfil,
  });
};

export default connect(mapStateToProps, actions)(Main);
